<ng-container *ngIf="hasTestItems(item)">
    <div class="tree-element">
        <span class="tree-col text">{{ item.name }}</span>
        <span
            class="tree-col adjustment"
            *ngIf="showAdjustments"
            [ngClass]="{ highlight: totalAdjustedValue !== totalClosingValue }"
            >{{ totalAdjustedValue | finNumber }}</span
        >
        <span class="tree-col current-year">{{ totalClosingValue | finNumber }}</span>
        <span class="tree-col">{{ totalOpeningValue | finNumber }}</span>
    </div>

    <div class="children">
        <ng-container *ngFor="let child of item.children">
            <ng-container [ngSwitch]="child.type">
                <app-fcp-bundle-item
                    *ngSwitchCase="FcpTreeItemType.Bundle"
                    [item]="child"
                    [showAdjustments]="showAdjustments"
                    [outputFinStatements]="outputFinStatements"
                    [filter]="filter"
                ></app-fcp-bundle-item>
                <app-fcp-test-group-item
                    *ngSwitchCase="FcpTreeItemType.TestGroup"
                    [item]="child"
                    [showAdjustments]="showAdjustments"
                    [outputFinStatements]="outputFinStatements"
                    [filter]="filter"
                ></app-fcp-test-group-item>
                <app-fcp-test-item
                    *ngSwitchCase="FcpTreeItemType.TestItem"
                    [item]="child"
                    [showAdjustments]="showAdjustments"
                    [outputFinStatements]="outputFinStatements"
                    [filter]="filter"
                ></app-fcp-test-item>
                <!-- Default case if no match found -->
                <div *ngSwitchDefault>{{ child.name }}</div>
            </ng-container>
        </ng-container>
    </div>
</ng-container>
